
//#region DevExtreme Imports

import 'devextreme/ui/list'
import 'devextreme/ui/popover'

//#endregion

import { GRID_SERVICE_NAME } from "../../../../services/grid"

import { IIMRCashierPanelLocatonDetailsController } from "./cashier-panel-location-details.controller"

import { CASHIER_PANEL_SERVICE_NAME, CASHIER_PANEL_LOCATION_DETAILS_SERVICE_NAME } from "../../services"
import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { $SCOPE_SERVICE_NAME, SYSTEM_SERVICE_NAME } from "../../../../services/system"
import { LOCATION_SERVICE_NAME } from "../../../../services/location"

//#region Asset Imports

import './cashier-panel-location-details.scss'
import * as TEMPLATE from './cashier-panel-location-details.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrCashierPanelLocationDetails'

export class IMRCashierPanelLocatonDetailsComponent implements ng.IComponentOptions {
    controller = [
        $SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        CASHIER_PANEL_SERVICE_NAME,
        CASHIER_PANEL_LOCATION_DETAILS_SERVICE_NAME,
        LOCATION_SERVICE_NAME,
        IIMRCashierPanelLocatonDetailsController
    ]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}
